import React, { useState } from "react";
import DieInput from "./DieInput";
import UserAvatar from "./UserAvatar";
import ReactTooltip from "react-tooltip";
import { DiceToRoll, AvatarDef } from "../models/messages";
import { DICE } from "../constants/general";

interface Props {
  onRollPerform: (diceToRoll: DiceToRoll) => void;
  userAvatar: AvatarDef | undefined;
}

export default function DiceBar(props: Props) {
  const { onRollPerform, userAvatar } = props;
  const [diceToRoll, setDiceToRoll] = useState<DiceToRoll>({
    d12: 0,
    d20: 0,
    d10: 0,
    d8: 0,
    d6: 0,
    d4: 0,
  });

  return (
    <div className="mb-2">
      <div className="d-flex flex-row justify-content-start align-items-center">
        <div className="ml-1" data-tip={"You"} data-place="bottom">
          {userAvatar && <UserAvatar avatarDef={userAvatar} />}
        </div>
        <div className="d-flex flex-grow-1 flex-row flex-wrap justify-content-start align-items-center mr-3">
          {DICE.map((die) => (
            <DieInput
              die={die}
              onDieCountChange={(count) => {
                setDiceToRoll((prevState) => ({ ...(prevState as DiceToRoll), [die]: count }));
              }}
              key={die}
            />
          ))}
        </div>

        <button
          type="button"
          className="btn btn-outline-light ml-auto mr font-weight-bold"
          onClick={() => onRollPerform(diceToRoll)}
        >
          Roll
        </button>
      </div>
      <ReactTooltip effect="solid" type="dark" />
    </div>
  );
}
